import { createAction, props } from "@ngrx/store";
import { TaxType } from "../model/tax.model";

export const loadTaxType = createAction('[tax-type] Load Tax Type');

export const loadTaxTypeSuccess = createAction(
  '[tax-type] Load Tax Type Success',
  props<{ taxType: TaxType[] }>()   // ✅ ARRAY
);
